export const AMP_PAGE_VIEW = 'nuvemenvio_view';
export const AMP_VIEW_WARNING = 'nuvemenvio_view_warning';
export const AMP_VIEW_DROPOFF = 'nuvemenvio_view_dropoff_banner';
export const AMP_BUTTON = 'nuvemenvio_click';
export const AMP_VIEW_APP_BLOCKED = 'nuvemenvio_view_app_blocked';

export enum AmpPages {
  DROPOFF_POINTS = 'dropoff points',
  SINGLE_SHIPMENT_STEP1 = 'single_shipment_page1',
  SINGLE_SHIPMENT_STEP2 = 'single_shipment_page2',
  SINGLE_SHIPMENT_STEP3 = 'single_shipment_page3',
  SINGLE_SHIPMENT_STEP4 = 'single_shipment_page4',
  REVERSE_SHIPMENT_STEP1 = 'reverse_shipment_page1',
  BANNER_LOGGI = 'Dashboard - Loggi invitation banner',
  CREATE_SUCURSAL = 'Create Sucursal',
  BILLING = 'billing',
  BILLING_HIGHLIGHT = 'Billing Highlight',
  BILLING_DETAILS = 'Billing Details',
  PREFERENCES = 'Preferences',
  CONFIGURATIONS = 'Configurations',
  DASHBOARD = 'dashboard',
  DASHBOARD_JADLOG = 'Dashboard - Jadlog invitation banner',
  DASHBOARD_PROMOTION_BANNER = 'Dashboard - Promotion banner',
  DASHBOARD_PROMOTION_BANNER_ACCEPTED = 'Dashboard - Promotion accepted banner',
  DASHBOARD_EMPTY_STATE = 'dashboard - empty state',
  SHIPPING_DETAILS = 'Shipping Details',
  GENERATE_TRACKING_FROM_ORDERS = 'Generate Tracking from Orders',
  CONFIGURATIONS_CARRIER = 'Configurations - Carrier',
  NUVEM_PAGO_STATUS = 'nuvemenvio_prepaid_add_funds_nuvempago',
  EXTERNAL_ORDERS_EMPTY_STATE = 'nuvemenvio_external_orders_empty_state_view',
  DASHBOARD_APP_BLOCKED = 'dashboard - app blocked',
  SAVE_ON_SHIPPING = 'save_on_shipping'
}

export enum AmpActions {
  DROPOFF_GET_DIRECTIONS = 'get directions',
  DROPOFF_SELECT_DISTRIBUITION_CENTER = 'select distribution center',
  DROPOFF_SHOW_MORE_DROPOFF_POINTS = 'show more dropoff points',
  SINGLE_SHIPMENT_CONTINUE = 'continue',
  SINGLE_SHIPMENT_CANCEL = 'cancel',
  SINGLE_SHIPMENT_CREATE = 'create',
  DISMISS_JADLOG_INVITATION_BANNER = 'dismiss Jadlog invitation banner',
  DISMISS_LOGGI_INVITATION_BANNER = 'dismiss Loggi invitation banner',
  INTENTION_JADLOG_ACTIVATE_BANNER = 'intention to activate Jadlog',
  INTENTION_LOGGI_ACTIVATE_BANNER = 'intention to activate Loggi',
  LEARN_MORE_BANNER_LOGGI = 'learn more about Loggi',
  CREATE_SHIPMENT_SUCURSAL = 'Create Shipment',
  CREATE_SHIPMENT_SUCURSAL_CONTINUE = 'Continue',
  BALANCE_ADD = 'Top up - Add',
  BILLING_GO_TO_DETAILS = 'Go to Details',
  BILLING_DETAILS_CYCLE_SELECTOR = 'Billing Details - Cycle Selector',
  BILLING_DETAILS_SHIPPING_LABEL_REPORT = 'Billing Details - Shipping Label Report',
  BILLING_DETAILS_WALLET_STATEMENT = 'Billing Details - Wallet Statement',
  CONFIGURATION_OPEN_DELIVERY_OPTION = 'Open delivery option configuration from Nuvem Envio',
  DASHBOARD_OPEN_LANDING_PAGE_EMPTY_STATE = 'Open landing page from Nuvem Envio empty state',
  CONFIGURATION_OPEN_PREFERENCES = 'Open preferences from Nuvem Envio',
  CONFIGURATION_OPEN_SETTINGS = 'Open Settings',
  PREFERENCES_SAVE_SETTINGS = 'Save settings',
  PREFERENCES_DROPOFF_ACTIVATION = 'dropoff points - Dropoff activation',
  PREFERENCES_DROPOFF_ACTIVATION_ACTIVATE = 'activate - Dropoff activation',
  PREFERENCES_DROPOFF_ACTIVATION_ERROR = 'Error Activate - Pontos de Postagem',
  PREFERENCES_DROPOFF_ACTIVATION_TERMS = 'terms and conditions - Dropoff activation',
  DASHBOARD_MARK_AS_SENT = 'Mark as sent - Dashboard',
  DASHBOARD_MARK_AS_SENT_PANEL = 'Mark as sent - Panel',
  DASHBOARD_REPRINT_LABEL = 'Reprint label - Dashboard',
  DASHBOARD_BUY_LABEL = 'Buy label - Dashboard',
  DASHBOARD_CANCEL_LABEL = 'Cancel Label - Dashboard',
  DASHBOARD_GENERATE_REVERSE = 'Generate Reverse - Dashboard',
  DASHBOARD_DUPLICATE_SHIPPING = 'Duplicate Shipping - Dashboard',
  DASHBOARD_OPEN_JADLOG_DROPOFF = 'Open jadlog dropoff points',
  DASHBOARD_OPEN_LOGGI_DROPOFF = 'Open loggi dropoff points',
  DASHBOARD_OPEN_DROPOFF_POINTS = 'Open dropoff points',
  DASHBOARD_OPEN_FREIGHT_CALCULATOR = 'Open freight calculator',
  DASHBOARD_OPEN_SEARCH_MODAL = 'Open search modal',
  DASHBOARD_IMPORT_SALE_SHIPPING_TYPE_CHANGE = 'Import a sale from shipping type change',
  DASHBOARD_IMPORT_MULTIPLE_SALES = 'Import multiple sales',
  DASHBOARD_IMPORT_SALE = 'Import a sale',
  DASHBOARD_OTHER_SHIPMENTS = 'Other Shipments',
  DASHBOARD_CREATE_SINGLE_SHIPMENT = 'Create single shipment',
  DASHBOARD_CREATE_REVERSE_SHIPMENT = 'Create reverse shipment',
  DASHBOARD_CREATE_SUCURSAL_SHIPMENT = 'Create sucursal shipment',
  DASHBOARD_ACTIVATE_DROPOFF_BANNER = 'activate - Dropoff Banner',
  DASHBOARD_DISMISS_DROPOFF_BANNER = 'dismiss - Dropoff Banner',
  DASHBOARD_LEARN_MORE_DROPOFF_BANNER = 'learn more - Dropoff Banner',
  DASHBOARD_ACTIVATE_JADLOG_BANNER = 'activate Jadlog banner - Dashboard',
  DASHBOARD_DISMISS_JADLOG_BANNER = 'dismiss Jadlog banner - Dashboard',
  DASHBOARD_LEARN_MORE_JADLOG_BANNER = 'learn more about Jadlog',
  DASHBOARD_EMPTY_STATE_ADD_CREDIT = 'Open add credit modal',
  DASHBOARD_EMPTY_STATE_OPEN_FREIGHT_CALCULATOR = 'Open freight calculator modal',
  EMPTY_STATE = 'empty-state',
  NO_PACKAGES = 'No Packages',
  NO_RESULTS = 'No results',
  SHIPPING_DETAILS_OPEN_SHIPPING_TYPE_CHANGE = 'Open shipping type change - Detail',
  SHIPPING_DETAILS_GO_TO_JADLOG_TRACKING = 'Shippment detail - go to jadlog tracking',
  SHIPPING_DETAILS_GO_TO_JADLOG_POINTS = 'Shippment detail - go to jadlog dropoff points',
  SHIPPING_DETAILS_GO_TO_DROPOFF_POINTS = 'Shippment detail - go to mandae dropoff points',
  SHIPPING_DETAILS_MARK_AS_SENT = 'Mark as sent - Detail',
  SHIPPING_DETAILS_DISPATCH_IN_PROGRESS = 'dispatch in progress',
  SHIPPING_DETAILS_DISPATCH_LIMIT = 'Limite de etiquetas atingido',
  SHIPPING_DETAILS_SAVE_CHANGE_FREIGHT = 'Save shipping type change - Detail',
  GENERATE_TRACKING_PRINT_BUTTON = 'button print',
  GENERATE_TRACKING_ADD_CREDIT_BUTTON = 'button add credit',
  GENERATE_TRACKING_NEED_RECHARGE = 'need recharge',
  GENERATE_TRACKING_CANCEL_BUTTON = 'button cancel',
  GENERATE_TRACKING_CREATE_BUTTON = 'Tracking creation/print - Panel',
  TUTORIALS_WATCH_VIDEO = 'Watch video',
  FILTERS_SEARCH = 'Search by modal',
  FREIGHT_CALCULATOR_CALCULATE = 'Calculate shipping',
  FREIGHT_CALCULATOR_CREATE_SHIPMENT = 'Create single shipment from calculator',
  GENERATE_ROMANEIO = 'Tracking creation/print - Panel - Romaneio',
  LANDING_PAGE_SETUP_CLICK = 'envionube_landing_setup_click',
  LANDING_PAGE_VIEW_CLICK = 'envionube_landing_view_click',
  CONFIGURATIONS_CARRIER_BUTTON_GO_TO_POINTS = 'go to points',
  CONFIGURATIONS_CARRIER_BUTTON_EDIT = 'edit carrier',
  CONFIGURATIONS_CARRIER_BUTTON_ACTIVATE = 'activate carrier',
  CONFIGURATIONS_CARRIER_BUTTON_DISABLE_CONFIRM = 'confirm disable carrier',
  CONFIGURATIONS_CARRIER_BUTTON_DISABLE = 'disable carrier',
  CONFIGURATIONS_CARRIER_BUTTON_FREIGHT_CALCULATOR = 'freight calculator',
  CONFIGURATIONS_CARRIER_CORREIOS_VINCULATE_CONTRACT = 'set up contrato correios',
  EN_INVOICE_VIEW_DETAILS_CLICK = 'envionube_postpaid_invoice_view_details_click',
  BANNER_PROMOTIONAL_ACTIVATE_BUTTON = 'promotion_accepted',
  BANNER_PROMOTIONAL_DISMISS_BUTTON = 'dismiss',
  BANNER_PROMOTIONAL_GO_TO_TUTORIALS_LINK = 'go_to_tutorial',
  EN_INVOICE_VIEW_MOVEMENTS_CLICK = 'envionube_postpaid_view_movements_click',
  EN_INVOICE_VIEW_HISTORY_CLICK = 'envionube_postpaid_view_history_click',
  DASHBOARD_ADDITIONAL_SERVICE_CLICK = 'envionube_additional_service_click',
  ADD_CREDIT_NUVEM_PAGO_CLICK = 'nuvemenvio_prepaid_add_funds_nuvempago_payment_method_selection_click',
  ADD_CREDIT_NUVEM_PAGO_RELOAD = 'nuvemenvio_prepaid_add_funds_nuvempago_payment_methods_selection_reload',
  ADD_CREDIT_OTHER_PAYMENT_CLICK = 'nuvemenvio_prepaid_add_funds_other_payment_methods_selection_click',
  NUVEMPAGO_ADD_CREDIT_CONFIRM = 'nuvemenvio_prepaid_add_funds_click',
  NUVEMPAGO_ADD_CREDIT_CANCEL = 'nuvemenvio_prepaid_add_funds__cancel_click',
  NUVEMPAGO_ADD_CREDIT_EDIT = 'nuvemenvio_prepaid_add_funds__edit_click',
  NUVEMPAGO_STATUS_PAGE_SUCCESS_CLICK = 'nuvemenvio_prepaid_add_funds_success_go_to_nuvemenvio_click',
  NUVEMPAGO_STATUS_PAGE_SUCCESS_PRINT_LABELS_CLICK = 'nuvemenvio_prepaid_add_funds_success_print-labels_click',
  NUVEMPAGO_STATUS_PAGE_ERROR_CLICK = 'nuvemenvio_prepaid_add_funds_error_change_payment_method_click',
  NUVEMPAGO_STATUS_PAGE_NUVEM_PAGO_REQUESTING_VIEW = 'nuvemenvio_prepaid_add_funds_nuvempago_payment_requesting_view',
  NUVEMPAGO_STATUS_PAGE_NUVEM_PAGO_SUCCESS_VIEW = 'nuvemenvio_prepaid_add_funds_nuvempago_payment_success_view',
  NUVEMPAGO_STATUS_PAGE_NUVEM_PAGO_ERROR_VIEW = 'nuvemenvio_prepaid_add_funds_nuvempago_payment_error_view',
  EXTERNAL_ORDERS_FILTERS_SEARCH = 'external_orders_filters_search_click',
  EXTERNAL_ORDERS_FILTERS_SEARCH_ERASE = 'external_orders_filters_search_erase_click',
  TAB_EXTERNAL_ORDERS_CLICK = 'external_orders_tab_click',
  BANNER_LOGGI_ACTIVATE_SUCCESS_BUTTON = 'loggi_activate_success_configuration_button_click',
  BANNER_LOGGI_INVITATION_VIEW = 'loggi_invitation_banner_view',
  SHIPPING_LABEL_PURCHASE_CLICK = 'nuvemenvio_shipping_label_purchase_click',
  SHIPPING_DETAIL_TRACKING_CODE_CLICK = 'nuvemenvio_shipping_detail_tracking_code_click',
  SHIPPING_DETAIL_TRACKING_COPY = 'nuvemenvio_shipping_detail_tracking_copy',
  SHIPPING_DETAIL_LABEL_REPRINT = 'nuvemenvio_shipping_detail_label_reprint',
  SHIPPING_DETAIL_LABEL_CANCEL = 'nuvemenvio_shipping_detail_label_cancel',
  MANUAL_SHIPMENT_CALCULATE_COST_CLICK = 'nuvemenvio_manual_shipment_calculate_cost_click',
  MANUAL_SHIPMENT_CANCEL_FORM_CLICK = 'nuvemenvio_manual_shipment_cancel_form_click',
  MANUAL_SHIPMENT_SELECT_ACTIVE_MODALITY_CLICK = 'nuvemenvio_manual_shipment_select_active_modality_click',
  MANUAL_SHIPMENT_SELECT_INACTIVE_MODALITY_CLICK = 'nuvemenvio_manual_shipment_select_inactive_modality_click',
  CHECKOUT_ENABLE_MODALITY_CLICK = 'nuvemenvio_checkout_enable_modality_click',
  MANUAL_SHIPMENT_EDIT_SUMMARY_CLICK = 'nuvemenvio_manual_shipment_edit_summary_click',
  MANUAL_SHIPMENT_CANCEL_SUMMARY_CLICK = 'nuvemenvio_manual_shipment_cancel_summary_click',
  DASHBOARD_PAID_AMOUNT_TOOLTIP_VIEW = 'nuvemenvio_shipping_list_paid_amount_tooltip_view',
  E_PICK_HIDDEN_WITHOUT_COVERAGE = 'nuvemenvio_e_pick_hidden_without_coverage',
  DASHBOARD_OPEN_NEXT_COLLECT = 'Open next collect details',
  DASHBOARD_CANCEL_COLLECT_CLICK = 'Click cancel collect',
  DASHBOARD_CANCEL_COLLECT_CONFIRM = 'Confirm cancel collect',
  SAVE_ON_SHIPPING_SEND_CLICK = 'nuvemenvio_save_on_shipping_send_click',
  SAVE_ON_SHIPPING_MIGRATE_RESULT = 'nuvemenvio_save_on_shipping_migrate_result'
}
